import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";

export type RoadQueryParams = {
  number: SearchReferenceDTO;
  carrier?: string | null;
  type?: string | null;
};
